(function(){
  'use strict';
  var d=document, SID='cava-cart-drawer';
  var recoCache={};

  function root(){return d.querySelector('[data-cd]');}
  function isPage(){var r=root();return !!(r&&r.hasAttribute('data-cd-page'));}
  function setCount(n){d.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=n;el.style.display=n>0?'':'none';});}
  function toast(m){if(window.cavaToast)window.cavaToast(m);}

  function open(){
    var r=root();if(!r||isPage())return;
    r.setAttribute('aria-hidden','false');
    d.documentElement.classList.add('cd-lock');
    var p=r.querySelector('.cd__panel');if(p)void p.getBoundingClientRect(); /* forceer layout, zodat de slide-animatie altijd start */
    r.classList.add('is-open');
    loadReco();
    setTimeout(function(){var c=r.querySelector('.cd__close');if(c)c.focus({preventScroll:true});},60);
  }
  function close(){
    var r=root();if(!r||isPage())return;
    r.classList.remove('is-open');r.setAttribute('aria-hidden','true');
    d.documentElement.classList.remove('cd-lock');
  }

  function render(html){
    var r=root();if(!html||!r)return;
    var tmp=d.createElement('div');tmp.innerHTML=html;
    var ni=tmp.querySelector('[data-cd-inner]'),oi=r.querySelector('[data-cd-inner]');
    if(ni&&oi){oi.parentNode.replaceChild(ni,oi);}
    if(ni&&ni.dataset.count!=null)setCount(parseInt(ni.dataset.count,10)||0);
    loadReco();
  }

  function busy(on){var r=root();if(r)r.classList.toggle('is-busy',on);}

  function post(url,body){
    busy(true);
    body.sections=SID;body.sections_url=location.pathname;
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
      .then(function(j){if(j.sections)render(j.sections[SID]);return j;})
      .catch(function(err){toast((err&&err.description)||'Dat lukte niet, probeer het opnieuw.');throw err;})
      .finally(function(){busy(false);});
  }
  function change(key,q){return post('/cart/change.js',{id:key,quantity:q});}
  function add(items){return post('/cart/add.js',{items:items});}
  function refresh(){
    return fetch(location.pathname+'?sections='+SID,{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();}).then(function(j){render(j[SID]);});
  }

  /* Automatische aanbevelingen */
  function fillReco(box,html){
    var track=box.querySelector('[data-cd-track]');if(!track)return;
    var tmp=d.createElement('div');tmp.innerHTML=html;
    var ex=(box.dataset.exclude||'').split(',');
    var lim=parseInt(box.dataset.limit,10)||4,n=0;
    track.innerHTML='';
    [].forEach.call(tmp.querySelectorAll('[data-cd-up]'),function(el){
      if(n>=lim||ex.indexOf(el.dataset.productId)>-1)return;
      track.appendChild(el);n++;
    });
    box.hidden=n===0;
  }
  function loadReco(){
    var r=root();if(!r)return;
    var box=r.querySelector('[data-cd-reco]');if(!box||!box.dataset.productId)return;
    if(!isPage()&&!r.classList.contains('is-open'))return;
    var pid=box.dataset.productId,intent=box.dataset.intent||'related',key=pid+'|'+intent;
    if(recoCache[key]!=null){fillReco(box,recoCache[key]);return;}
    var lim=(parseInt(box.dataset.limit,10)||4)+4;
    fetch('/recommendations/products?product_id='+pid+'&limit='+lim+'&intent='+intent+'&section_id=cava-cart-reco')
      .then(function(res){return res.text();})
      .then(function(t){recoCache[key]=t;var b=root()&&root().querySelector('[data-cd-reco]');if(b)fillReco(b,t);})
      .catch(function(){});
  }

  d.addEventListener('click',function(e){
    var t=e.target;
    var r=root();if(!r)return;

    /* Header-winkelwagen opent de drawer */
    var link=t.closest('a[href$="/cart"],[data-cart-open]');
    if(link&&!isPage()&&!link.closest('[data-cd]')){e.preventDefault();open();return;}

    if(!r.contains(t))return;
    if(t.closest('[data-cd-close]')){close();return;}

    var q=t.closest('[data-cd-qty]');
    if(q){change(q.dataset.key,Math.max(0,parseInt(q.dataset.q,10)||0));return;}

    var sc=t.closest('[data-cd-scroll]');
    if(sc){var tr=r.querySelector('[data-cd-track]');if(tr)tr.scrollBy({left:(parseInt(sc.dataset.cdScroll,10)||1)*tr.clientWidth*.7,behavior:'smooth'});return;}

    var a=t.closest('[data-cd-add]');
    if(a){
      var card=a.closest('[data-cd-up]'),v=card&&card.querySelector('[data-cd-up-variant]');
      if(!v||!v.value)return;
      a.classList.add('is-added');
      add([{id:parseInt(v.value,10),quantity:1}]).catch(function(){a.classList.remove('is-added');});
    }
  });
  d.addEventListener('keydown',function(e){if(e.key==='Escape')close();});

  /* Productformulieren (data-ajax-cart): toevoegen + winkelwagen verversen/openen.
     Capture-fase, zodat de oude handler in cava-app.js niet ook nog toevoegt. */
  d.addEventListener('submit',function(e){
    var f=e.target&&e.target.closest?e.target.closest('form[data-ajax-cart]'):null;
    if(!f||!root())return;
    e.preventDefault();e.stopPropagation();
    var btn=f.querySelector('[type=submit]');if(btn)btn.disabled=true;
    var fd=new FormData(f);fd.append('sections',SID);fd.append('sections_url',location.pathname);
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
      .then(function(j){
        if(j.sections)render(j.sections[SID]);else refresh();
        if(window.cavaCart.openOnAdd()&&!isPage())open();else toast('In je winkelwagen ◈');
      })
      .catch(function(err){toast((err&&err.description)||'Kon niet toevoegen — check je maat.');})
      .finally(function(){if(btn)btn.disabled=false;});
  },true);

  window.cavaCart={open:open,close:close,render:render,refresh:refresh,add:add,change:change,
    sectionId:SID,
    openOnAdd:function(){var r=root();return !!(r&&r.dataset.cdOpenOnAdd==='true');}};

  /* In de thema-editor: sectie selecteren = drawer openen */
  d.addEventListener('shopify:section:select',function(e){if(e.target&&e.target.querySelector&&e.target.querySelector('[data-cd]'))open();});
  d.addEventListener('shopify:section:deselect',function(e){if(e.target&&e.target.querySelector&&e.target.querySelector('[data-cd]'))close();});
  d.addEventListener('shopify:section:load',function(e){if(e.target&&e.target.querySelector&&e.target.querySelector('[data-cd]'))open();});
})();
